const SpecialFolder = {
  PUBLIC_FOLDER: "public_folder"
};

module.exports = SpecialFolder;
